import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Layout.css';

const Layout = () => {
  const { user, logout, hasRole } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getMenuItems = () => {
    const items = [];
    
    items.push({ path: '/', label: 'Главная', roles: ['admin', 'manager', 'operator', 'service'] });
    items.push({ path: '/shifts', label: 'Смены', roles: ['admin', 'manager', 'operator', 'service'] });
    items.push({ path: '/objects', label: 'Объекты', roles: ['admin', 'manager', 'operator', 'service'] });
    
    if (hasRole(['admin'])) {
      items.push({ path: '/branches', label: 'Филиалы', roles: ['admin'] });
      items.push({ path: '/users', label: 'Пользователи', roles: ['admin'] });
    }
    
    return items;
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-left">
          <h1>🛡️ Диспетчер</h1>
        </div>
        <div className="header-right">
          <span className="user-info">
            {user?.full_name || user?.username} ({user?.role})
          </span>
          <button className="btn-logout" onClick={handleLogout}>
            Выйти
          </button>
        </div>
      </header>

      {hasRole(['admin', 'manager', 'operator', 'service']) && (
        <nav className="nav">
          <ul>
            {getMenuItems().map((item) => (
              <li key={item.path}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
      )}

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
